import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './index.module.scss';
import { Table, TableRow, TableHeadCell, TableCell, TableColgroup } from 'vendor/Table';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const CountryListTable = ({ countryData }) => (
  <Table
    data-qa="country-list-table"
    className={styles.table}
    colgroup={
      <TableColgroup
        cols={[
          { key: 'gutter', colWidth: 50 },
          { key: 'country', colWidth: '*' },
          { key: 'streams', colWidth: 140 },
        ]}
      />
    }
    head={
      <TableRow>
        <TableHeadCell className={styles.bordered}>#</TableHeadCell>
        <TableHeadCell className={styles.bordered}>
          <FormattedMessage
            id="network.audience.country.title"
            description="Title of country chart"
            defaultMessage="Country"
          />
        </TableHeadCell>
        <TableHeadCell className={classNames(styles.bordered, styles.highlight)} alignRight>
          <FormattedMessage
            id="network.audience.country.streams"
            description="Title of Streams column in country chart"
            defaultMessage="Streams"
          />
        </TableHeadCell>
      </TableRow>
    }
    body={countryData.map((d, i) => (
      <TableRow key={d.name} data-qa="country-list-table-body-row">
        <TableCell className={classNames(styles['body-cell'], styles.bordered)} numerical>
          <FormattedNumber value={i + 1} />
        </TableCell>
        <TableCell
          className={classNames(styles['body-cell'], styles.bordered)}
          highlight
          truncate
          title={d.name}
        >
          {d.name}
        </TableCell>
        <TableCell
          className={classNames(styles['body-cell'], styles.bordered)}
          numerical
          alignRight
          title={d.count}
        >
          <FormattedNumber value={d.count} />
        </TableCell>
      </TableRow>
    ))}
  />
);

CountryListTable.displayName = 'CountryListTable';
CountryListTable.propTypes = {
  countryData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    }),
  ),
};
